var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextArrow5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 117,
    viewBox: "0 0 179 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 59.3108C21.88 44.8521 46.7214 32.8866 71.1058 38.1459C86.689 41.507 100.472 55.9922 102.092 71.8991C103.622 86.922 98.8544 102.773 84.0168 108.788C76.283 111.923 68.1562 111.264 63.2669 103.808C55.7972 92.4165 62.555 74.3449 69.9991 64.7519C93.2309 34.8141 136.756 17.0418 174.21 23.8516",
    stroke: "#00667C",
    strokeWidth: 5.13409,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.546 6.65723C157.251 10.08 170.029 18.2945 175.505 23.7709",
    stroke: "#00667C",
    strokeWidth: 5.13409,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.505 23.771C169.801 27.1937 157.023 35.4083 151.546 40.8846",
    stroke: "#00667C",
    strokeWidth: 5.13409,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow5);
export default __webpack_public_path__ + "static/media/next-arrow-5.e83d815f87e6d13a15d1ca4e4b34beff.svg";
export { ForwardRef as ReactComponent };